import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Upload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 16.303a1 1 0 011 1v2.039c0 2.206-1.795 4-4 4H4.999c-2.205 0-4-1.794-4-4v-2.04a1 1 0 112 0v2.04c0 1.103.898 2 2 2h13.77c1.103 0 2-.897 2-2v-2.04a1 1 0 011-1zM11.852 1h.021a1.011 1.011 0 01.076.005l.02.002.031.005.014.002.011.001a1 1 0 01.056.011l.02.006a1.002 1.002 0 01.088.026l.024.01a.997.997 0 01.078.034l.032.016a.995.995 0 01.219.157l.01.011.019.019c0 .002.002.004.004.005l4.993 5.242a.999.999 0 11-1.449 1.378L12.851 4.5V18a1 1 0 11-2 0V4.499L7.585 7.93a1 1 0 11-1.449-1.378l4.992-5.242a.96.96 0 01.062-.06l.03-.025.03-.024-.088.075a1.01 1.01 0 01.186-.14l.028-.016a.58.58 0 01.036-.018l.011-.006a.993.993 0 01.091-.038l.017-.005a.999.999 0 01.091-.027l.018-.003a1.006 1.006 0 01.095-.016l.03-.003A1.01 1.01 0 0111.84 1h.012z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoUpload = React.memo(Upload);
export default MemoUpload;